/*
export function someMutation (state) {
}
*/

export const setLogin = (state, data) => {
  state.user = data
  state.loggedIn = true
}

export const setLogout = (state) => {
  state.loggedIn = false
  state.user = {
    user: {}
  }
}
